import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

interface UpdateProps {
  event_id: number;
  event_title: string;
  event_img: string;
  event_category:string;
  thumbnail_image: string;
  event_date: string;
  slug: string;
}

const MoreUpdateItem: React.FC<{ item: UpdateProps }> = ({ item }) => {
  const [imgLoading, setImgLoading] = useState(true);
  const imgRef = useRef<HTMLImageElement | null>(null);

  const imageUrl = item?.thumbnail_image || "";
  const hasImage = Boolean(imageUrl);

  useEffect(() => {
    setImgLoading(true);

    // ✅ HANDLE CACHED IMAGE
    if (imgRef.current && imgRef.current.complete) {
      setImgLoading(false);
    }
  }, [imageUrl]);

  return (
    <Link
      to={`/updates/${item.slug}`}
      className="more_update_listing d-flex"
      style={{ textDecoration: "none", color: "inherit" }}
    >
      <div className="img_thumbnail">
        {/* Skeleton */}
        {(imgLoading || !hasImage) && (
          <div className="placeholder-glow">
            <span
              className="placeholder rounded d-block"
              style={{ width: "171px", height: "96px" }}
            />
          </div>
        )}

        {/* Images */}
        {hasImage && (
          <>
            {/* Desktop / Tablet */}
            <img
              ref={imgRef}
              className="web_thumb d-none d-md-block"
              src={imageUrl}
              alt={item.event_title}
              onLoad={() => setImgLoading(false)}
              onError={() => setImgLoading(false)}
            />

            {/* Mobile */}
            <img
              className="mob_thumb d-block d-md-none"
              src={imageUrl}
              alt={item.event_title}
              onLoad={() => setImgLoading(false)}
              onError={() => setImgLoading(false)}
            />
          </>
        )}
      </div>

      <div className="short_details upates_card_info">
        <span className="update_type">{item.event_category}</span>
        <p className="title_heading">{item.event_title}</p>
        <p className="posting_date">
          {new Date(item.event_date).toDateString()}
        </p>
      </div>
    </Link>
  );
};

export default MoreUpdateItem;
